<script setup lang="ts"></script>

<template>
  <div>
    <!-- bagian header -->
     <Hero/>
    <!-- bagian tour -->
    <Destinations />
    <!-- bagian footer -->
     <TheFooter />
  </div>
</template>

<style scoped></style>
